import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./HongTimePicker.scss"; // 커스텀 스타일 (선택사항)

const HongTimePicker = ({ selectedTime, onTimeChange, interVal=15 }) => {
  const [time, setTime] = useState(selectedTime || new Date());

  const handleTimeChange = (newTime) => {
    setTime(newTime);
    if (onTimeChange) {
      onTimeChange(newTime);
    }
  };

  return (
    <div className="time-picker-container">
      <DatePicker
        selected={time} // 선택된 시간
        onChange={handleTimeChange} // 시간이 변경될 때 호출
        showTimeSelect // 시간 선택 활성화
        showTimeSelectOnly // 시간 선택만 가능
        timeIntervals={interVal} // 15분 단위 선택
        timeCaption="시간" // 시간 캡션
        dateFormat="h:mm aa" // 시간 형식
        className="timePicker" // 입력 필드 스타일 클래스
        popperClassName="custom-datepicker-popper" // 팝업 스타일 클래스
        popperPlacement="bottom" // 팝업 위치
        enableTabLoop={false} // 키보드 탐색 방지클릭시 오른쪽 밀림 방지
        // portalId="root-portal" // 부모 위에 뜨게 (이거 하니까 팝업이 오히려 안 되네 fixed에서)
      />
    </div>
  );
};

export default HongTimePicker;
